import * as React from 'react';

import Dialog from '@material-ui/core/Dialog';

import modalsConfig from './config';
import { IModal, IModalsProps as IProps } from './interfaces';
import { Modal } from './Modal';

export class Modals extends React.Component<IProps> {
  public render() {
    const { closeModal, modals } = this.props;
    const isOpen = this.calcVisibility();

    return (
      <Dialog
        open={isOpen}
        onClose={closeModal}
        aria-labelledby="responsive-dialog-title"
      >
        {modalsConfig.map(
          item =>
            (modals[item.name] as IModal).isOpen && (
              <Modal
                key={item.name}
                config={item}
                state={modals[item.name] as IModal}
                handleClose={closeModal}
              />
            ),
        )}
      </Dialog>
    );
  }

  private readonly calcVisibility = () =>
    !!Object.values(this.props.modals).find(
      (item: IModal | false) => item && item.isOpen,
    );
}
